import { GetClaimsToRoleType } from "../../types/Role";
import { get } from "../../utils/axios-config";
import { ROLES_GET_CLAIMS } from "../../utils/constants";

export const getClaimsToRole = async (role: string) => await get<GetClaimsToRoleType[]>(`${ROLES_GET_CLAIMS}?Role=${role}`);